export default "__VITE_ASSET__C7w56bJH__"